import theme from '@adsk/alloy-react-theme';

export const nameStyle = (status) => ({
  alignSelf: 'center',
  paddingBottom: '5px',
  ...theme.typography.bodyMediumBold,
  ...(status !== 'active' && { color: 'grey' }),
});

export const emailStyle = {
  color: theme.colors.adskBlue700,
  textDecoration: 'none',
  ...theme.typography.bodyMedium,
};

export const phoneStyle = (status) => ({
  paddingBottom: '3px',
  ...(status !== 'active' && { color: 'grey' }),
  ...theme.typography.bodyMedium,
});

export const avatarContainer = {
  paddingRight: '10px',
  alignSelf: 'center',
  flex: '0 0 64px',
};

export const mainContainerStyles = { padding: '16px 16px 0 16px' };

export const centerContainerStyles = { wordBreak: 'break-word' };

export const rightContainerStyles = (variant) => ({
  marginLeft: 'auto',
  position: 'relative',
  flex: variant === 'account' ? '0 0 90px' : '0 0 74px',
  textAlign: 'right',
});

export const optionsMenuContainerStyles = { display: 'inline-flex' };

export const dividerStyles = { marginTop: '20px' };

export const activeColor = theme.colors.green500;

export const invitedColor = theme.colors.adskBlue500;

export const flexContainer = { display: 'flex' };

export const memberInfoHeaderTop = { display: 'flex', flexDirection: 'row' };

export const badgeContainer = { paddingTop: '5px' };

export const leftContainerStyle = { flex: '1' };
